// import phoneMask from "../Components/phoneMask";
import moment from "moment";
import "moment/locale/es";
import { dineroDisabledMask, round2Decimals } from "../Components/Items";
import numeroALetra from "../Components/numeroALetra";
import { formatQRTotal } from "../Components/RoundQRDecimals";

moment.locale('es')

const cartaPortePdf = (values) => {
  const empresa = values.respuestaFactura.empresa;
  const dataSat = values.respuestaFactura.dataSat;
  const dataExtra = values.respuestaFactura.data;
  let cartaPorte

  if (dataSat?.Complemento?.Any[0]["cartaporte31:CartaPorte"]) {
    cartaPorte = dataSat.Complemento.Any[0]["cartaporte31:CartaPorte"]
  }

  if (dataSat?.Complemento?.Any[0]["cartaporte30:CartaPorte"]) {
    cartaPorte = dataSat.Complemento.Any[0]["cartaporte30:CartaPorte"]
  }

  const conceptos = dataSat.Conceptos.map((valueConcepto) => {
    let iva = 0;
    let ieps = 0;
    valueConcepto?.Impuestos?.Traslados.map((valueImpuesto) => {
      if (valueImpuesto.Impuesto === "002" && valueImpuesto.Importe) {
        iva += valueImpuesto.Importe;
      }
      if (valueImpuesto.Impuesto === "003" && valueImpuesto.Importe) {
        ieps += valueImpuesto.Importe;
      }
      return null;
    });
    return [
      { style: "textoTablaChico", text: valueConcepto.Cantidad, alignment: "right" },
      {
        text: valueConcepto.ClaveUnidad,
        style: "textoTablaChico",
        alignment: "center",
      },
      {
        text: valueConcepto.ClaveProdServ,
        style: "textoTablaChico",
        alignment: "center",
      },
      {
        text: valueConcepto.Descripcion + (valueConcepto.Observaciones ? ("\n" + valueConcepto.Observaciones) : ""),
        style: "textoTablaChico",
        alignment: "left",
      },
      {
        text: dineroDisabledMask(iva),
        style: "textoTablaChico",
        alignment: "right",
      },
      {
        text: dineroDisabledMask(ieps),
        style: "textoTablaChico",
        alignment: "right",
      },
      {
        text: dineroDisabledMask(valueConcepto.ValorUnitario),
        style: "textoTablaChico",
        alignment: "right",
      },
      {
        text: dineroDisabledMask(valueConcepto.Importe),
        style: "textoTablaChico",
        alignment: "right",
      },
    ];
  });

  let nuevoArrayImpFL
  let nuevoArrayRetFL

  if (dataSat?.Complemento?.Any?.[0]?.["implocal:ImpuestosLocales"]) {
    nuevoArrayImpFL = Array.isArray(dataSat?.Impuestos?.Traslados) ?
      [...dataSat.Impuestos.Traslados, ...(dataSat?.Complemento?.Any?.[0]?.["implocal:ImpuestosLocales"]?.["implocal:TrasladosLocales"] || [])]
      :
      [...(dataSat?.Complemento?.Any?.[0]?.["implocal:ImpuestosLocales"]?.["implocal:TrasladosLocales"] || [])]
    nuevoArrayRetFL = Array.isArray(dataSat.Impuestos.Retenciones) ?
      [...dataSat.Impuestos.Retenciones, ...(dataSat?.Complemento?.Any?.[0]?.["implocal:ImpuestosLocales"]?.["implocal:RetencionesLocales"] || [])]
      :
      [...(dataSat?.Complemento?.Any?.[0]?.["implocal:ImpuestosLocales"]?.["implocal:RetencionesLocales"] || [])]
  } else {
    nuevoArrayImpFL = Array.isArray(dataSat?.Impuestos?.Traslados) ?
      [...dataSat.Impuestos.Traslados,]
      :
      []
    nuevoArrayRetFL = Array.isArray(dataSat?.Impuestos?.Retenciones) ?
      [...dataSat.Impuestos.Retenciones,]
      :
      []
  }

  // Definir orden personalizado
  const ordenImpuestos = ["IVA 0%", "IVA 16%", "IEPS 6%", "IEPS 7%", "IEPS 9%"];

  // Ordenar el array antes del map
  const nuevoArrayImpFLOdenado = [...nuevoArrayImpFL].sort((a, b) => {
    const nombreA = a.Impuesto === "002"
      ? `IVA ${round2Decimals(a.TasaOCuota * 100)}%`
      : a.Impuesto === "003"
        ? `IEPS ${round2Decimals(a.TasaOCuota * 100)}%`
        : a["@ImpLocTrasladado"];
    const nombreB = b.Impuesto === "002"
      ? `IVA ${round2Decimals(b.TasaOCuota * 100)}%`
      : b.Impuesto === "003"
        ? `IEPS ${round2Decimals(b.TasaOCuota * 100)}%`
        : b["@ImpLocTrasladado"];

    return ordenImpuestos.indexOf(nombreA) - ordenImpuestos.indexOf(nombreB);
  });


  const impuestosTotales = nuevoArrayImpFLOdenado.map(
    (valueImpuesto, indexImpuesto) => {
      let nombre = "";
      if (valueImpuesto.Impuesto === "002") {
        nombre = "IVA";
      } else if (valueImpuesto.Impuesto === "003") {
        nombre = "IEPS";
      } else {
        nombre = valueImpuesto["@ImpLocTrasladado"]
      }

      if (valueImpuesto.TipoFactor === "Tasa") {
        nombre = nombre + " " + round2Decimals(valueImpuesto.TasaOCuota * 100) + "%";
      } else if (valueImpuesto.TipoFactor === "Cuota") {
        nombre = nombre + " $" + round2Decimals(valueImpuesto.TasaOCuota);
      }

      let border = indexImpuesto + 1 === nuevoArrayImpFLOdenado.length;
      return [
        {
          border: [true, false, false, border],
          text: nombre,
          style: "subheader",
        },
        {
          border: [false, false, true, border],
          text: dineroDisabledMask(valueImpuesto.Importe || valueImpuesto["@Importe"] || 0),
          style: "textoChico",
          alignment: "right",
        },
      ];
    }
  );

  const retencionesTotales = nuevoArrayRetFL.map(
    (valueRetencion, indexRetencion) => {
      let nombre = "Retención ";
      if (valueRetencion.Impuesto === "001") {
        nombre = nombre + "ISR";
      } else if (valueRetencion.Impuesto === "002") {
        nombre = nombre + "IVA";
      } else {
        nombre = valueRetencion["@ImpLocRetenido"]
      }

      let border = indexRetencion + 1 === nuevoArrayRetFL.length;
      return [
        {
          border: [true, false, false, border],
          text: nombre,
          style: "subheader",
        },
        {
          border: [false, false, true, border],
          text: dineroDisabledMask(valueRetencion.Importe || valueRetencion["@Importe"]),
          style: "textoChico",
          alignment: "right",
        },
      ];
    }
  )

  let totalImpFL
  let totalRetFL

  if (dataSat?.Complemento?.Any?.[0]?.["implocal:ImpuestosLocales"]) {
    totalImpFL = dataSat.Impuestos?.TotalImpuestosTrasladados + (dataSat?.Complemento?.Any?.[0]?.["implocal:ImpuestosLocales"]?.["@TotaldeTraslados"] || 0) || 0
    totalRetFL = dataSat.Impuestos?.TotalImpuestosRetenidos + (dataSat?.Complemento?.Any?.[0]?.["implocal:ImpuestosLocales"]?.["@TotaldeRetenciones"] || 0) || 0

  } else {
    totalImpFL = dataSat.Impuestos?.TotalImpuestosTrasladados || 0
    totalRetFL = dataSat.Impuestos?.TotalImpuestosRetenidos || 0

  }

  let cancelado = {}
  if (values.estado === 0) {
    cancelado = { watermark: { text: 'CANCELADO', color: 'GRAY', opacity: 0.3, bold: true, italics: false, angle: -50, fontSize: 110 } }
  }
  const arraySiHayRetenciones = totalRetFL > 0 ? [
    //   [
    //   {
    //     border: [true, false, false, false],
    //     text: "Retenciones:",
    //     style: "subheader",
    //   },
    //   {
    //     border: [false, false, true, false],
    //     text: dineroDisabledMask(
    //       totalRetFL
    //     ),
    //     style: "textoChico",
    //     alignment: "right",
    //   },
    // ],
    [
      {
        border: [true, false, false, true],
        text: "TOTAL PAGO:",
        style: "header",
        fillColor: "#e8e8e8",
      },
      {
        border: [false, false, true, true],
        text: dineroDisabledMask(dataSat.Total),
        style: "header",
        fillColor: "#e8e8e8",
        alignment: "right",
      },
    ]] : []

  const total = dataSat.SubTotal - dataSat.Descuento + totalImpFL

  let agregarSiIngreso = []
  let agregarSiTraslado = []

  const totalqr = formatQRTotal(dataSat.Total)
  let cadena8 = dataExtra.selloCFDI
  cadena8 = cadena8.slice(-8)

  const linkqr = `https://verificacfdi.facturaelectronica.sat.gob.mx/default.aspx?&id=${dataExtra.uuid}&re=${empresa.rfc}&rr=${dataSat.Receptor.Rfc}&tt=${totalqr}&fe=${cadena8}`


  if (dataSat.TipoDeComprobante === 'I') {
    agregarSiIngreso.push(
      {
        style: "tablaSinMargen",
        table: {
          widths: ["20%", "50%", "30%"],
          layout: {
            defaultBorder: true,
          },
          body: [
            [
              { qr: linkqr, alignment: "left", fit: 100 },
              {
                table: {
                  widths: ["30%", "70%"],
                  layout: {
                    defaultBorder: false,
                  },
                  body: [
                    [
                      {
                        border: [true, true, false, false],
                        text: "Cantidad con letra:",
                        style: "subheader",
                      },
                      {
                        border: [false, true, true, false],
                        text: "**( " + numeroALetra(dataSat.Total, dataSat.Moneda) + " )**",
                        style: "textoChico",
                        fontSize: 7,
                      },
                    ],
                    [
                      {
                        border: [true, false, false, false],
                        text: "Uso de CFDI:",
                        style: "subheader",
                      },
                      {
                        border: [false, false, true, false],
                        text:
                          "(" +
                          dataSat.usoDeCFDI.c_UsoCFDI +
                          ") " +
                          dataSat.usoDeCFDI.descripcion,
                        style: "textoChico",
                      },
                    ],
                    [
                      {
                        border: [true, true, false, false],
                        text: "Banco:",
                        style: "subheader",
                      },
                      {
                        border: [false, true, true, false],
                        text: empresa.banco ? empresa.banco : "",
                        style: "textoChico",
                      },
                    ],
                    ...(empresa.swiftCode ? [[
                      {
                        border: [true, false, false, false],
                        text: "Swift Code:",
                        style: "subheader",
                      },
                      {
                        border: [false, false, true, false],
                        text: empresa.swiftCode ? empresa.swiftCode : "",
                        style: "textoChico",
                      },
                    ]] : []),
                    ...(empresa.abaCode ? [[
                      {
                        border: [true, false, false, false],
                        text: "ABA Code:",
                        style: "subheader",
                      },
                      {
                        border: [false, false, true, false],
                        text: empresa.abaCode ? empresa.abaCode : "",
                        style: "textoChico",
                      },
                    ]] : []),
                    [
                      {
                        border: [true, false, false, false],
                        text: "Cuenta:",
                        style: "subheader",
                      },
                      {
                        border: [false, false, true, false],
                        text: empresa.cuentaBanco ? empresa.cuentaBanco : "",
                        style: "textoChico",
                      },
                    ],
                    [
                      {
                        border: [true, false, false, true],
                        text: "Cuenta CLABE:",
                        style: "subheader",
                      },
                      {
                        border: [false, false, true, true],
                        text: empresa.cuentaClabe ? empresa.cuentaClabe : "",
                        style: "textoChico",
                      },
                    ],
                  ],
                },
                layout: {
                  hLineWidth: function (i, node) {
                    return i === 0 || i === node.table.body.length ? 1 : 1;
                  },
                  vLineWidth: function (i, node) {
                    return i === 0 || i === node.table.widths.length ? 1 : 1;
                  },
                  hLineColor: function (i, node) {
                    return "#adaaaa";
                  },
                  vLineColor: function (i, node) {
                    return "#adaaaa";
                  },
                  hLineStyle: function (i, node) {
                    if (i === 0 || i === node.table.body.length) {
                      return null;
                    }
                    return { dash: { length: 2, space: 1 } };
                  },
                  vLineStyle: function (i, node) {
                    if (i === 0 || i === node.table.widths.length) {
                      return null;
                    }
                    return { dash: { length: 2 } };
                  },
                },
              },
              {
                table: {
                  widths: ["50%", "50%"],
                  layout: {
                    defaultBorder: false,
                  },
                  body: [
                    [
                      {
                        border: [true, true, false, false],
                        text: "Subtotal:",
                        style: "subheader",
                      },
                      {
                        border: [false, true, true, false],
                        text: dineroDisabledMask(dataSat.SubTotal),
                        style: "textoChico",
                        alignment: "right",
                      },
                    ],
                    [
                      {
                        border: [true, false, false, false],
                        text: "Descuento:",
                        style: "subheader",
                      },
                      {
                        border: [false, false, true, false],
                        text: dineroDisabledMask(dataSat.Descuento),
                        style: "textoChico",
                        alignment: "right",
                      },
                    ],
                    ...impuestosTotales,
                    [
                      {
                        border: [true, false, false, true],
                        text: "TOTAL:",
                        style: "header",
                        fillColor: "#e8e8e8",
                      },
                      {
                        border: [false, false, true, true],
                        text: dineroDisabledMask(total),
                        style: "header",
                        fillColor: "#e8e8e8",
                        alignment: "right",
                      },
                    ],
                    ...retencionesTotales,
                    ...arraySiHayRetenciones,
                  ],
                },
                layout: {
                  hLineWidth: function (i, node) {
                    return i === 0 || i === node.table.body.length ? 1 : 1;
                  },
                  vLineWidth: function (i, node) {
                    return i === 0 || i === node.table.widths.length ? 1 : 1;
                  },
                  hLineColor: function (i, node) {
                    return "#adaaaa";
                  },
                  vLineColor: function (i, node) {
                    return "#adaaaa";
                  },
                  hLineStyle: function (i, node) {
                    if (i === 0 || i === node.table.body.length) {
                      return null;
                    }
                    return { dash: { length: 2, space: 1 } };
                  },
                  vLineStyle: function (i, node) {
                    if (i === 0 || i === node.table.widths.length) {
                      return null;
                    }
                    return { dash: { length: 2 } };
                  },
                },
              },
            ],
          ],
        },
        layout: "noBorders",
      },
    )
    agregarSiTraslado.push(
      [
        {
          colSpan: 4,
          text: '"Este documento es una representacion impresa de un CFDI"',
          style: "header",
          alignment: "center",
        },
        {},
        {},
        {},
      ],
    )
  } else {
    agregarSiTraslado.push(
      [
        {
          qr: linkqr, alignment: "left", fit: 100
        },
        {
          colSpan: 3,
          text: '"Este documento es una representacion impresa de un CFDI"',
          style: "header",
          alignment: "center",
        },
        {},
        {},
      ],
    )
  }

  let ubicaciones = []

  if (cartaPorte?.Ubicaciones) {
    for (const ubicacion of cartaPorte.Ubicaciones) {
      ubicaciones.push(
        [
          {
            style: 'textoTablaChico',
            text: ubicacion.TipoUbicacion,
            alignment: 'center'
          },
          {
            style: 'textoTablaChico',
            text: ubicacion.RFCRemitenteDestinatario,
            alignment: 'center'
          },
          {
            style: 'textoTablaChico',
            text: ubicacion.NombreRemitenteDestinatario,
            alignment: 'lefth'
          },
          {
            text: 'MXN',
            style: 'textoTablaChico',
            alignment: 'center'
          },
          { text: '-', style: 'textoTablaChico', alignment: 'center' },
          { text: ubicacion.FechaHoraSalidaLlegada, style: 'textoTablaChico', alignment: 'center' },
        ],
        [
          { style: 'textoTablaChico', text: 'Domicilio:', alignment: 'lefth' },
          { style: 'textoTablaChico', text: (ubicacion.Domicilio.Calle ? ubicacion.Domicilio.Calle : '') + (ubicacion.Domicilio.NumeroExterior ? (' #' + ubicacion.Domicilio.NumeroExterior) : '') + (ubicacion.Domicilio.NumeroInterior ? (' - ' + ubicacion.Domicilio.NumeroInterior) : '') + ' Col: ' + ubicacion.Domicilio.ColoniaNombre + ' CP: ' + ubicacion.Domicilio.CodigoPostal + (ubicacion.Domicilio.Referencia ? (' Referencia: ' + ubicacion.Domicilio.Referencia) : '') + ' - ' + (ubicacion.Domicilio.MunicipioNombre ? ubicacion.Domicilio.MunicipioNombre : '') + ' ' + ubicacion.Domicilio.Estado + ' ' + ubicacion.Domicilio.Pais, alignment: 'lefth', colSpan: 5 },
          {},
          {},
          {},
          {},
        ]
      )
    }
  }


  let figuras = []

  if (cartaPorte?.FiguraTransporte) {
    for (const figura of cartaPorte.FiguraTransporte) {
      let tipoFiguraTexto

      if (figura.TipoFigura === '01') {
        tipoFiguraTexto = "Operador"
      } else if (figura.TipoFigura === '02') {
        tipoFiguraTexto = "Propietario"
      } else if (figura.TipoFigura === '03') {
        tipoFiguraTexto = "Arrendador"
      } else if (figura.TipoFigura === '04') {
        tipoFiguraTexto = "Notificado"
      }

      const filaDomicilioFigura = figura?.Domicilio && Object.keys(figura.Domicilio).length > 0
        ? [
          [
            { style: 'textoTablaChico', text: 'Domicilio:', alignment: 'left' },
            {
              style: 'textoTablaChico',
              text:
                (figura.Domicilio.Calle ? figura.Domicilio.Calle : '') +
                (figura.Domicilio.NumeroExterior ? ` #${figura.Domicilio.NumeroExterior}` : '') +
                (figura.Domicilio.NumeroInterior ? ` - ${figura.Domicilio.NumeroInterior}` : '') +
                (figura.Domicilio.ColoniaNombre ? ` Col: ${figura.Domicilio.ColoniaNombre}` : '') +
                (figura.Domicilio.CodigoPostal ? ` CP: ${figura.Domicilio.CodigoPostal}` : '') +
                (figura.Domicilio.Referencia ? ` Referencia: ${figura.Domicilio.Referencia}` : '') +
                (figura.Domicilio.MunicipioNombre ? ` - ${figura.Domicilio.MunicipioNombre}` : '') +
                (figura.Domicilio.Estado ? ` ${figura.Domicilio.Estado}` : '') +
                (figura.Domicilio.Pais ? ` ${figura.Domicilio.Pais}` : ''),
              alignment: 'left',
              colSpan: 5
            },
            {},
            {},
            {},
            {}
          ]
        ]
        : [];

      figuras.push(
        [
          {
            style: 'textoTablaChico',
            text: figura.TipoFigura + ' - ' + tipoFiguraTexto,
            alignment: 'center'
          },
          {
            style: 'textoTablaChico',
            text: figura.RFCFigura,
            alignment: 'center'
          },
          {
            style: 'textoTablaChico',
            text: figura.NombreFigura,
            alignment: 'lefth'
          },
          {
            text: figura.NumLicencia,
            style: 'textoTablaChico',
            alignment: 'center'
          },
          { text: figura.ResidenciaFiscalFigura ? figura.ResidenciaFiscalFigura : '-', style: 'textoTablaChico', alignment: 'center' },
          { text: figura.NumRegIdTribFigura ? figura.NumRegIdTribFigura : '-', style: 'textoTablaChico', alignment: 'center' },
        ],
        ...filaDomicilioFigura
      )
    }
  }


  let mercancias = []

  if (cartaPorte?.Mercancias?.Mercancia) {
    for (const mercancia of cartaPorte.Mercancias.Mercancia) {
      mercancias.push(
        [
          { style: 'textoTablaChico', text: mercancia.Cantidad, alignment: 'right' },
          {
            text: mercancia.Unidad,
            style: 'textoTablaChico',
            alignment: 'center'
          },
          {
            text: mercancia.BienesTransp + ' - ' + mercancia.Descripcion,
            style: 'textoTablaChico',
            alignment: 'center'
          },
          {
            text: mercancia.CveMaterialPeligroso ? mercancia.CveMaterialPeligroso : 'No',
            style: 'textoTablaChico',
            alignment: 'left'
          },
          {
            text: mercancia.Embalaje ? (mercancia.Embalaje + ' - ' + mercancia.DescripEmbalaje) : '-',
            style: 'textoTablaChico',
            alignment: 'right'
          },
          {
            text: mercancia.PesoEnKg,
            style: 'textoTablaChico',
            alignment: 'right'
          },
          {
            text: mercancia.FraccionArancelaria,
            style: 'textoTablaChico',
            alignment: 'right'
          },
          {
            text: mercancia.PermisoImportacion ? mercancia.PermisoImportacion : '-',
            style: 'textoTablaChico',
            alignment: 'right'
          }
        ],
      )

      if (mercancia.GuiasIdentificacion) {
        for (const guiaIdent of mercancia.GuiasIdentificacion) {
          mercancia.push(
            [
              { text: 'No. de Guia', style: 'tituloTabla', colSpan: 2 },
              {},
              { text: guiaIdent.NumeroGuiaIdentificacion, style: 'textoTablaChico', alignment: 'right' },
              { text: 'Descripción Guía', style: 'tituloTabla' },
              { text: guiaIdent.DescripGuiaIdentificacion, style: 'textoTablaChico', alignment: 'right', colSpan: 2 },
              {},
              { text: 'Peso Guía', style: 'tituloTabla' },
              { text: guiaIdent.PesoGuiaIdentificacion, style: 'textoTablaChico', alignment: 'right' }
            ]
          )
        }
      }


    }
  }

  let remolques = []

  if (cartaPorte?.Mercancias?.Autotransporte?.Remolques) {

    let dataRemolques = cartaPorte?.Mercancias?.Autotransporte?.Remolques.map(valueR => [
      {
        text: valueR.SubTipoRem + ' - ' + valueR.DescripcionSubtipo,
        style: 'textoTablaChico',
        alignment: 'center'
      },
      {
        text: valueR.Placa,
        style: 'textoTablaChico',
        alignment: 'center'
      },
    ])



    remolques.push(
      { text: 'Remolques', style: 'tableHeader' },
      {
        style: 'tableExample',
        table: {
          widths: ['50%', '50%'],
          layout: { defaultBorder: true },
          body: [
            [
              { text: 'Subtipo Remolque', style: 'tituloTabla' },
              { text: 'Placa', style: 'tituloTabla' },
            ],
            ...dataRemolques,
          ]
        },
        layout: {
          fillColor: (rowIndex, node, columnIndex) => {
            return rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff";
          },
          hLineWidth: function (i, node) {
            return i === 0 || i === node.table.body.length ? 1 : 1;
          },
          vLineWidth: function (i, node) {
            return i === 0 || i === node.table.widths.length ? 1 : 1;
          },
          hLineColor: function (i, node) {
            return "#adaaaa";
          },
          vLineColor: function (i, node) {
            return "#adaaaa";
          },
          hLineStyle: function (i, node) {
            if (i === 0 || i === node.table.body.length) {
              return null;
            }
            return { dash: { length: 2, space: 1 } };
          },
          vLineStyle: function (i, node) {
            if (i === 0 || i === node.table.widths.length) {
              return null;
            }
            return { dash: { length: 2 } };
          },
        }
      },
    )
  }


  mercancias.push(
    [
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {}
    ],
    [
      { text: 'Peso Bruto Total', style: 'tituloTabla', colSpan: 2 },
      {},
      { text: cartaPorte.Mercancias.PesoBrutoTotal, style: 'textoTablaChico', alignment: 'right' },
      { text: 'Unidad de Peso', style: 'tituloTabla' },
      { text: cartaPorte.Mercancias.UnidadPeso, style: 'textoTablaChico', alignment: 'right', colSpan: 2 },
      {},
      { text: 'Numero Mercancias', style: 'tituloTabla' },
      { text: cartaPorte.Mercancias.NumTotalMercancias, style: 'textoTablaChico', alignment: 'right' }
    ]
  )

  var dd = {
    ...cancelado,
    footer: { border: [false, false, false, false], image: 'logo1', alignment: 'center', fit: [65, 65] },
    content: [
      {
        style: 'tableExample',
        table: {
          widths: ['18%', '52%', '30%'],
          layout: { defaultBorder: false },

          body: [
            [
              {
                border: [false, false, false, false],
                image: "logo",
                fit: [80, 80]
              },
              {
                border: [false, false, false, false],
                table: {
                  headerRows: 1,
                  widths: ["100%"],

                  body: [
                    [
                      {
                        text: (empresa.nombreComercial ? empresa.nombreComercial : empresa.persona
                          ? empresa.nombre
                          : empresa.nombre +
                          " " +
                          empresa.apellidoPaterno +
                          " " +
                          empresa.apellidoMaterno),
                        style: "tableHeader",
                      },
                    ],
                    [
                      {
                        text: "R.F.C: " + empresa.rfc,
                        style: "textoChico",
                        alignment: "center",
                      },
                    ],
                    [
                      {
                        text:
                          empresa.calle +
                          " " +
                          empresa.numeroCalle +
                          " " +
                          (empresa.numeroInterior
                            ? empresa.numeroInterior
                            : ""),
                        style: "textoChico",
                        alignment: "center",
                      },
                    ],
                    [
                      {
                        text:
                          empresa.colonia.tipoAsentamiento +
                          " " +
                          empresa.colonia.nombre +
                          " C.P. " +
                          empresa.colonia.cp +
                          " " +
                          empresa.municipio.nombre +
                          " " +
                          empresa.estado.abreviatura +
                          " " +
                          empresa.pais.abreviatura +
                          " ",
                        style: "textoChico",
                        alignment: "center",
                      },
                    ],
                    // empresa.telefono ? [
                    //     {
                    //         text: 'Tel: '+phoneMask(empresa.telefono),
                    //         style: "textoChico",
                    //         alignment: "center",
                    //       },
                    // ] : [],
                    [
                      {
                        text:
                          "Regimen Fiscal: (" +
                          empresa.regimenFiscal.c_RegimenFiscal +
                          ") " +
                          empresa.regimenFiscal.descripcion,
                        style: "textoChico",
                        alignment: "center",
                      },
                    ],
                    [
                      {
                        text: "Tipo De Comprobante: (" + dataSat.TipoDeComprobante + ") " + (dataSat.TipoDeComprobante === 'T' ? 'Traslado' : "Ingreso"),
                        style: "textoChico",
                        alignment: "center",
                      },
                    ],
                  ],
                },
                layout: "noBorders",
              },
              {
                border: [false, false, false, false],
                table: {
                  headerRows: 1,
                  widths: ['100%'],
                  body: [
                    [
                      {
                        text: 'N° Carta Porte:',
                        style: 'subheader',
                        alignment: 'center'
                      }
                    ],
                    [
                      {
                        text: dataSat.Serie + ' - ' + dataSat.Folio,
                        style: 'textoChico',
                        alignment: 'center'
                      }
                    ]
                  ]
                },
                layout: 'noBorders',

              }
            ]
          ]
        },
      },

      {
        style: 'tableExample',
        table: {
          widths: ['60%', '40%'],
          layout: { defaultBorder: false },
          body: [
            [
              {
                table: {
                  widths: ['30%', '70%'],
                  layout: { defaultBorder: false },
                  body: [
                    [
                      {
                        text: 'Nombre del cliente :',
                        style: 'subheader'
                      },
                      {
                        text: dataSat.Receptor.Nombre,
                        style: 'textoChico'
                      }
                    ],
                    [
                      { text: 'R.F.C :', style: 'subheader' },
                      { text: dataSat.Receptor.Rfc, style: 'textoChico' }
                    ],
                    [
                      { text: 'Uso de CFDI:', style: 'subheader' },
                      {
                        text: "(" +
                          dataSat.usoDeCFDI.c_UsoCFDI +
                          ") " +
                          dataSat.usoDeCFDI.descripcion, style: 'textoChico'
                      }
                    ]
                  ]
                },
                layout: 'noBorders'
              },
              {
                table: {
                  widths: ['40%', '60%'],
                  layout: { defaultBorder: false },
                  body: [
                    [
                      { text: 'Fecha:', style: 'subheader' },
                      {
                        text: moment(dataSat.Fecha).locale("es").format("LL"),
                        style: 'textoChico'
                      }
                    ],
                    [
                      {
                        text: 'Lugar de expedicion:',
                        style: 'subheader'
                      },
                      { text: dataSat.LugarExpedicion, style: 'textoChico' }
                    ]
                  ]
                },
                layout: 'noBorders'
              }
            ]
          ]
        },
        layout: {
          fillColor: (rowIndex, node, columnIndex) => {
            return rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff";
          },
          hLineWidth: function (i, node) {
            return i === 0 || i === node.table.body.length ? 1 : 1;
          },
          vLineWidth: function (i, node) {
            return i === 0 || i === node.table.widths.length ? 1 : 1;
          },
          hLineColor: function (i, node) {
            return "#adaaaa";
          },
          vLineColor: function (i, node) {
            return "#adaaaa";
          },
          hLineStyle: function (i, node) {
            if (i === 0 || i === node.table.body.length) {
              return null;
            }
            return { "radius": 20, dash: { length: 2, space: 1 } };
          },
          vLineStyle: function (i, node) {
            if (i === 0 || i === node.table.widths.length) {
              return null;
            }
            return { dash: { length: 2 } };
          },
        }
      },
      { text: 'Conceptos', style: 'tableHeader' },
      {
        style: "tableExample",
        table: {
          widths: ["8%", "6%", "9%", "38%", "8%", "8%", "10.5%", "12.5%"],
          layout: {
            defaultBorder: true,
          },
          body: [
            [
              { text: "Cantidad", style: "tituloTabla" },
              { text: "Unidad", style: "tituloTabla" },
              { text: "Clave SAT", style: "tituloTabla" },
              { text: "Descripción", style: "tituloTabla" },
              { text: "IVA", style: "tituloTabla" },
              { text: "IEPS", style: "tituloTabla" },
              { text: "P/U", style: "tituloTabla" },
              { text: "Importe", style: "tituloTabla" },
            ],
            ...conceptos,
          ],
        },
        layout: {
          fillColor: (rowIndex, node, columnIndex) => {
            return rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff";
          },
          hLineWidth: function (i, node) {
            return i === 0 || i === node.table.body.length ? 1 : 1;
          },
          vLineWidth: function (i, node) {
            return i === 0 || i === node.table.widths.length ? 1 : 1;
          },
          hLineColor: function (i, node) {
            return "#adaaaa";
          },
          vLineColor: function (i, node) {
            return "#adaaaa";
          },
          hLineStyle: function (i, node) {
            if (i === 0 || i === node.table.body.length) {
              return null;
            }
            return { dash: { length: 2, space: 1 } };
          },
          vLineStyle: function (i, node) {
            if (i === 0 || i === node.table.widths.length) {
              return null;
            }
            return { dash: { length: 2 } };
          },
        },
      },
      ...agregarSiIngreso,
      { text: 'Detalle Complemento Carta Porte', style: 'tableHeader' },
      {
        style: 'tableExample',
        table: {
          widths: ['20%', '20%', '20%', '20%', '20%'],
          layout: { defaultBorder: true },
          body: [
            [
              { text: 'Transporte Internacional', style: 'tituloTabla' },
              { text: 'Tipo de transporte', style: 'tituloTabla' },
              { text: 'Via de Transporte', style: 'tituloTabla' },
              { text: 'País de Orígen o Destino', style: 'tituloTabla' },
              { text: 'Total distancia recorrida', style: 'tituloTabla' },
            ],
            [
              {
                style: 'textoTablaChico',
                text: cartaPorte["TranspInternac"],
                alignment: 'center'
              },
              {
                text: '-',
                style: 'textoTablaChico',
                alignment: 'center'
              },
              { text: '-', style: 'textoTablaChico', alignment: 'center' },
              { text: 'MXN', style: 'textoTablaChico', alignment: 'center' },
              {
                text: cartaPorte["TotalDistRec"],
                style: 'textoTablaChico',
                alignment: 'right'
              },
            ]
          ]
        },
        layout: {
          fillColor: (rowIndex, node, columnIndex) => {
            return rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff";
          },
          hLineWidth: function (i, node) {
            return i === 0 || i === node.table.body.length ? 1 : 1;
          },
          vLineWidth: function (i, node) {
            return i === 0 || i === node.table.widths.length ? 1 : 1;
          },
          hLineColor: function (i, node) {
            return "#adaaaa";
          },
          vLineColor: function (i, node) {
            return "#adaaaa";
          },
          hLineStyle: function (i, node) {
            if (i === 0 || i === node.table.body.length) {
              return null;
            }
            return { dash: { length: 2, space: 1 } };
          },
          vLineStyle: function (i, node) {
            if (i === 0 || i === node.table.widths.length) {
              return null;
            }
            return { dash: { length: 2 } };
          },
        }
      },
      { text: 'Detalle de Transporte', style: 'tableHeader' },
      {
        style: 'tableExample',
        table: {
          widths: ['30%', '10%', '40%', '10%', '10%'],
          layout: { defaultBorder: true },
          body: [
            [
              { text: 'Permiso SCT', style: 'tituloTabla' },
              { text: 'No. de permiso SCT', style: 'tituloTabla' },
              { text: 'Configuración Vehicular / Tipo de remolque', style: 'tituloTabla' },
              { text: 'Placa', style: 'tituloTabla' },
              { text: 'Año', style: 'tituloTabla' },
            ],
            [
              {
                style: 'textoTablaChico',
                text: dataSat.tipoPermiso.Clave + ' - ' + dataSat.tipoPermiso.Descripcion,
                alignment: 'center'
              },
              {
                text: cartaPorte.Mercancias.Autotransporte.NumPermisoSCT,
                style: 'textoTablaChico',
                alignment: 'center'
              },
              { text: dataSat.configVehicular.Clave + ' - ' + dataSat.configVehicular.Descripcion, style: 'textoTablaChico', alignment: 'center' },
              { text: cartaPorte.Mercancias.Autotransporte.IdentificacionVehicular.PlacaVM, style: 'textoTablaChico', alignment: 'center' },
              {
                text: cartaPorte.Mercancias.Autotransporte.IdentificacionVehicular.AnioModeloVM,
                style: 'textoTablaChico',
                alignment: 'center'
              },
            ]
          ]
        },
        layout: {
          fillColor: (rowIndex, node, columnIndex) => {
            return rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff";
          },
          hLineWidth: function (i, node) {
            return i === 0 || i === node.table.body.length ? 1 : 1;
          },
          vLineWidth: function (i, node) {
            return i === 0 || i === node.table.widths.length ? 1 : 1;
          },
          hLineColor: function (i, node) {
            return "#adaaaa";
          },
          vLineColor: function (i, node) {
            return "#adaaaa";
          },
          hLineStyle: function (i, node) {
            if (i === 0 || i === node.table.body.length) {
              return null;
            }
            return { dash: { length: 2, space: 1 } };
          },
          vLineStyle: function (i, node) {
            if (i === 0 || i === node.table.widths.length) {
              return null;
            }
            return { dash: { length: 2 } };
          },
        }
      },
      {
        style: 'tableExample',
        table: {
          widths: ['15%', '15%', '15%', '15%', '15%', '15%', '10%'],
          layout: { defaultBorder: true },
          body: [
            [
              { text: 'Seguro de Responsabilidad Civil', colSpan: 2, style: 'tituloTabla' },
              {},
              { text: 'Seguro de Medio Ambiente', colSpan: 2, style: 'tituloTabla' },
              {},
              { text: 'Seguro de Carga', colSpan: 2, style: 'tituloTabla' },
              {},
              { text: 'Prima Seguro', rowSpan: 2, style: 'tituloTabla' },
            ],
            [
              { text: 'Aseguradora', style: 'tituloTabla' },
              { text: 'Póliza', style: 'tituloTabla' },
              { text: 'Aseguradora', style: 'tituloTabla' },
              { text: 'Póliza', style: 'tituloTabla' },
              { text: 'Aseguradora', style: 'tituloTabla' },
              { text: 'Póliza', style: 'tituloTabla' },
              {},
            ],
            [
              {
                style: 'textoTablaChico',
                text: cartaPorte.Mercancias.Autotransporte.Seguros.AseguraRespCivil,
                alignment: 'center'
              },
              {
                style: 'textoTablaChico',
                text: cartaPorte.Mercancias.Autotransporte.Seguros.PolizaRespCivil,
                alignment: 'center'
              },
              {
                style: 'textoTablaChico',
                text: cartaPorte.Mercancias.Autotransporte.Seguros.AseguraMedAmbiente,
                alignment: 'center'
              },
              {
                text: cartaPorte.Mercancias.Autotransporte.Seguros.PolizaMedAmbiente,
                style: 'textoTablaChico',
                alignment: 'center'
              },
              { text: cartaPorte.Mercancias.Autotransporte.Seguros.AseguraCarga, style: 'textoTablaChico', alignment: 'center' },
              { text: cartaPorte.Mercancias.Autotransporte.Seguros.PolizaCarga, style: 'textoTablaChico', alignment: 'center' },
              {
                text: cartaPorte.Mercancias.Autotransporte.Seguros.PrimaSeguro,
                style: 'textoTablaChico',
                alignment: 'center'
              },
            ]
          ]
        },
        layout: {
          fillColor: (rowIndex, node, columnIndex) => {
            return rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff";
          },
          hLineWidth: function (i, node) {
            return i === 0 || i === node.table.body.length ? 1 : 1;
          },
          vLineWidth: function (i, node) {
            return i === 0 || i === node.table.widths.length ? 1 : 1;
          },
          hLineColor: function (i, node) {
            return "#adaaaa";
          },
          vLineColor: function (i, node) {
            return "#adaaaa";
          },
          hLineStyle: function (i, node) {
            if (i === 0 || i === node.table.body.length) {
              return null;
            }
            return { dash: { length: 2, space: 1 } };
          },
          vLineStyle: function (i, node) {
            if (i === 0 || i === node.table.widths.length) {
              return null;
            }
            return { dash: { length: 2 } };
          },
        }
      },
      ...remolques,
      { text: 'Ubicaciones', style: 'tableHeader' },
      {
        style: 'tableExample',
        table: {
          widths: ['10%', '10%', '30%', '15%', '15%', '20%'],
          layout: { defaultBorder: true },
          body: [
            [
              { text: 'Descripción', style: 'tituloTabla' },
              { text: 'RFC', style: 'tituloTabla' },
              { text: 'Nombre', style: 'tituloTabla' },
              { text: 'Residencia Fiscal', style: 'tituloTabla' },
              { text: 'Identidad Tributaria', style: 'tituloTabla' },
              { text: 'Fecha de Salida / LLegada', style: 'tituloTabla' },
            ],
            ...ubicaciones
          ]
        },
        layout: {
          fillColor: (rowIndex, node, columnIndex) => {
            return rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff";
          },
          hLineWidth: function (i, node) {
            return i === 0 || i === node.table.body.length ? 1 : 1;
          },
          vLineWidth: function (i, node) {
            return i === 0 || i === node.table.widths.length ? 1 : 1;
          },
          hLineColor: function (i, node) {
            return "#adaaaa";
          },
          vLineColor: function (i, node) {
            return "#adaaaa";
          },
          hLineStyle: function (i, node) {
            if (i === 0 || i === node.table.body.length) {
              return null;
            }
            return { dash: { length: 2, space: 1 } };
          },
          vLineStyle: function (i, node) {
            if (i === 0 || i === node.table.widths.length) {
              return null;
            }
            return { dash: { length: 2 } };
          },
        }
      },
      { text: 'Figuras de Transporte', style: 'tableHeader' },
      {
        style: 'tableExample',
        table: {
          widths: ['10%', '10%', '30%', '15%', '15%', '20%'],
          layout: { defaultBorder: true },
          body: [
            [
              { text: 'Descripción', style: 'tituloTabla' },
              { text: 'RFC', style: 'tituloTabla' },
              { text: 'Nombre', style: 'tituloTabla' },
              { text: 'Licencia', style: 'tituloTabla' },
              { text: 'Residencia Fiscal', style: 'tituloTabla' },
              { text: 'Identidad Tributaria', style: 'tituloTabla' },

            ],
            ...figuras,

          ]
        },
        layout: {
          fillColor: (rowIndex, node, columnIndex) => {
            return rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff";
          },
          hLineWidth: function (i, node) {
            return i === 0 || i === node.table.body.length ? 1 : 1;
          },
          vLineWidth: function (i, node) {
            return i === 0 || i === node.table.widths.length ? 1 : 1;
          },
          hLineColor: function (i, node) {
            return "#adaaaa";
          },
          vLineColor: function (i, node) {
            return "#adaaaa";
          },
          hLineStyle: function (i, node) {
            if (i === 0 || i === node.table.body.length) {
              return null;
            }
            return { dash: { length: 2, space: 1 } };
          },
          vLineStyle: function (i, node) {
            if (i === 0 || i === node.table.widths.length) {
              return null;
            }
            return { dash: { length: 2 } };
          },
        }
      },
      { text: 'Detalle Mercancias', style: 'tableHeader' },
      {
        style: 'tableExample',
        table: {
          widths: ['7%', '8%', '30%', '10%', '10%', '10%', '10%', '15%'],
          layout: { defaultBorder: true },
          body: [
            [
              { text: 'Cantidad', style: 'tituloTabla' },
              { text: 'Unidad', style: 'tituloTabla' },
              { text: 'Clave / Descripcion', style: 'tituloTabla' },
              { text: 'Tipo Material peligroso', style: 'tituloTabla' },
              { text: 'Embalaje', style: 'tituloTabla' },
              { text: 'Peso en Kg', style: 'tituloTabla' },
              { text: 'Fraccion Arancelaria', style: 'tituloTabla' },
              { text: 'Pedimento', style: 'tituloTabla' }
            ],
            ...mercancias
          ]
        },
        layout: {
          fillColor: (rowIndex, node, columnIndex) => {
            return rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff";
          },
          hLineWidth: function (i, node) {
            return i === 0 || i === node.table.body.length ? 1 : 1;
          },
          vLineWidth: function (i, node) {
            return i === 0 || i === node.table.widths.length ? 1 : 1;
          },
          hLineColor: function (i, node) {
            return "#adaaaa";
          },
          vLineColor: function (i, node) {
            return "#adaaaa";
          },
          hLineStyle: function (i, node) {
            if (i === 0 || i === node.table.body.length) {
              return null;
            }
            return { dash: { length: 2, space: 1 } };
          },
          vLineStyle: function (i, node) {
            if (i === 0 || i === node.table.widths.length) {
              return null;
            }
            return { dash: { length: 2 } };
          },
        }
      },
      {
        table: {
          widths: ["15%", "30%", "23%", "32%"],
          layout: {
            defaultBorder: false,
          },
          body: [
            ...agregarSiTraslado,
            [
              { text: "Folio Fiscal: ", style: "subheader" },
              { text: dataExtra.uuid, style: "textoDatoFiscal" },
              { text: "Fecha y Hora de Certificación: ", style: "subheader" },
              {
                text: dataSat.Fecha,
                style: "textoDatoFiscal",
              },
            ],
            [
              { colSpan: 4, text: "Sello digital CFDI: ", style: "subheader" },
              {},
              {},
              {},
            ],
            [
              {
                colSpan: 4,
                text: dataExtra.selloCFDI,
                style: "textoChicoData",
              },
              {},
              {},
              {},
            ],
            [
              {
                colSpan: 2,
                text: "Numero de serie del Certificado de Sello digital: ",
                style: "subheader",
              },
              {},
              {
                colSpan: 2,
                text: "Numero de serie del Certificado de Sello digital del SAT: ",
                style: "subheader",
              },
              {},
            ],
            [
              {
                colSpan: 2,
                text: dataExtra.noCertificadoCFDI,
                style: "textoDatoFiscal",
              },
              {},
              {
                colSpan: 2,
                text: dataExtra.noCertificadoSAT,
                style: "textoDatoFiscal",
              },
              {},
            ],
            [
              {
                colSpan: 4,
                text: "Cadena Original del complemento de certificación Digital SAT: ",
                style: "subheader",
              },
              {},
              {},
              {},
            ],
            [
              {
                colSpan: 4,
                text: dataExtra.cadenaOriginalSAT,
                style: "textoChicoData",
              },
              {},
              {},
              {},
            ],
            [
              {
                colSpan: 4,
                text: "Sello Digital del SAT: ",
                style: "subheader",
              },
              {},
              {},
              {},
            ],
            [
              {
                colSpan: 4,
                text: dataExtra.selloSAT,
                style: "textoChicoData",
              },
              {},
              {},
              {},
            ],
            [
              {
                colSpan: 4,
                text: "Sello Digital del CFDI: ",
                style: "subheader",
              },
              {},
              {},
              {},
            ],
            [
              {
                colSpan: 4,
                text: dataExtra.selloCFDI,
                style: "textoChicoData",
              },
              {},
              {},
              {},
            ],
          ],
        },
        layout: "noBorders",
      },
    ],
    styles: {
      header: { fontSize: 9, bold: true },
      subheader: { fontSize: 8, bold: true },
      tableExample: { margin: [0, 5, 0, 5] },
      tablaSinMargen: { margin: [0, 0, 0, 0] },
      tableHeader: { bold: true, fontSize: 12, color: 'black', alignment: 'center' },
      textoChico: { fontSize: 8 },
      textoChicoData: { fontSize: 6 },
      textoDatoFiscal: { fontSize: 8 },
      tituloTabla: {
        fontSize: 8,
        bold: true,
        fillColor: '#cccccc',
        style: 'subheader',
        alignment: 'center',
        border: true
      },
      textoTabla: { fontSize: 8, italics: false },
      textoTablaChico: { fontSize: 6, italics: false }
    },
    images: {
      logo: empresa.logo.base64Completa,
      logo1: 'data:image/jpeg;base64,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'
    },
    pageSize: 'LETTER',
    defaultStyle: { columnGap: 20 }
  }
  return dd;
};

export default cartaPortePdf;
